 
import './App.css';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import Home from './components/Home/Home';
import ProductDetails from './components/ProductDetails/ProductDetails';
import UserManual from './components/UserManual/UserManual';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import TermsOfUse from './components/TermsOfuse/TermsOfUse';

function App() {
  return (
    <div>
       <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/details/:id" element={<ProductDetails />} />
            <Route path="/usermanual" element={<UserManual />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
        </Routes>
       </BrowserRouter>
    </div>
  );
}

export default App;
